import { Directive, Input, forwardRef } from '@angular/core'
import {
    NG_VALIDATORS,
    Validator,
    AbstractControl,
    Validators,
    ValidationErrors
} from '@angular/forms'

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[min]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: MinDirective, multi: true }
    ]
})
export class MinDirective implements Validator {
    @Input() min: number

    validate(control: AbstractControl): ValidationErrors {
        return Validators.min(this.min)(control)
    }
}



// WEBPACK FOOTER //
// ./src/app/common/min.directive.ts